var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1665 10.5001C22.1665 15.8762 17.4974 20.2904 11.6665 20.2904C5.83558 20.2904 1.1665 15.8762 1.1665 10.5001C1.1665 5.12391 5.83558 0.709747 11.6665 0.709747C17.4974 0.709747 22.1665 5.12391 22.1665 10.5001Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1815 5.78975H9.3515V9.94475H14.0165V5.78975H15.1715V15.2097H14.0165V10.9497H9.3515V15.2097H8.1815V5.78975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH);
export default __webpack_public_path__ + "static/media/H.cd27b746bf7337932607cce2f0c1a8b2.svg";
export { ForwardRef as ReactComponent };